module.exports = __webpack_public_path__ + "static/media/ic_youtube.cba48789.svg";